import { ICounterpartyOrdersParams } from '@app/models/interfaces';
import { CounterpartyOrderSchema, CounterpartyWarehouseOrderSchema, WarehouseFlowStatus } from '@app/models/orders';
import { Module } from '@app/models/users';

export const COUNTERPARTY_ORDERS_PATH = '/dashboard/counterparty-orders';

export const ALL_TAB = 'all';
export type OrdersTab = typeof ALL_TAB | Module;
export const MODULE_TABS: Module[] = [Module.Warehouse, Module.Delivery, Module.Supply];

// Складские статусы, с которыми заказ виден во вкладке «Склады»
export const WAREHOUSE_TAB_STATUSES: WarehouseFlowStatus[] = [
  WarehouseFlowStatus.Assembled,
  WarehouseFlowStatus.Shipped,
  WarehouseFlowStatus.Cancelled,
];

export type CounterpartyOrderRow = CounterpartyOrderSchema | CounterpartyWarehouseOrderSchema;

export interface IOrdersPage {
  items: CounterpartyOrderRow[];
  total?: number;
}

export type IOrdersFilters = Omit<ICounterpartyOrdersParams, 'limit' | 'offset'>;
